// Auth bearer store — Plan 08-02.
//
// B12 firewall (CONTEXT line 44): JWT scoped to user identity ONLY; no
// game state persists here. Game state lives in Durable Objects.
//
// Persistence: localStorage under the key `runegambit.auth.bearer`. The
// store-key is the SINGLE source of auth persistence in the client; never
// read or write Bearer state from anywhere else (sessionStorage, cookies,
// memory caches, etc.).

import { persistentAtom } from '@nanostores/persistent'
import type { AuthExchangeResult, BearerStored } from '../auth/types.js'

export const AUTH_STORAGE_KEY = 'runegambit.auth.bearer'

export const $authBearer = persistentAtom<BearerStored | null>(
  AUTH_STORAGE_KEY,
  null,
  {
    encode: (value) => JSON.stringify(value),
    decode: (raw) => {
      if (!raw) return null
      try {
        return JSON.parse(raw) as BearerStored
      } catch {
        // Malformed payload from a previous version — drop it; user will
        // be routed to splash + re-login on next render.
        return null
      }
    },
  },
)

/**
 * Persist a successful exchange result. Single writer; AuthProvider mounts
 * are idempotent because nanostores's persistentAtom is its own coalescer.
 */
export function saveAuth(result: AuthExchangeResult): void {
  $authBearer.set({
    jwt: result.session_jwt,
    exp_ms: result.exp_ms,
    idp_kind: result.idp_kind,
    user_uuid: result.user_uuid,
  })
}

/**
 * Clear the Bearer atom. Called on:
 *   - explicit logout
 *   - any 401 from `/api/auth/exchange` or `apiFetch`
 *   - silent-refresh failure that bubbles past the lock
 */
export function clearAuth(): void {
  $authBearer.set(null)
}
